import React, { createContext, useContext, useState, ReactNode } from 'react';


// types.ts (create this if needed)
export interface Address {
  id: string;
  street: string;
  city: string;
  pincode: string;
  firstName:string;
  lastName:string;
  mobile:string;
  isDefault:boolean;
}

export interface CartItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
}

export interface User {
  id: string;
  name: string;
//   addresses: Address[];
}

export interface CheckoutContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  cart: CartItem[];
  setCart: React.Dispatch<React.SetStateAction<CartItem[]>>;
  address: Address | null;
  setAddress: React.Dispatch<React.SetStateAction<Address | null>>;
}

const CheckoutContext = createContext<CheckoutContextType | undefined>(undefined);

export const CheckoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [cart, setCart] = useState<CartItem[]>([]);
  const [address, setAddress] = useState<Address | null>(null);

  return (
    <CheckoutContext.Provider value={{ user, setUser, cart, setCart, address, setAddress }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => {
  const context = useContext(CheckoutContext);
  if (context === undefined) {
    throw new Error("useCheckout must be used within a CheckoutProvider");
  }
  return context;
};

